<template>
  <div v-show='cpntMostrar' class="rf-input-group" :class='cpntClassDivField' @keyup='onKeyPress'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <template v-if="inputTipoBusca === false">
        <input
          style='padding-right: 30px;'
          :ref='cpntId'

          :id='cpntId' 
          type="text" 
          :tabIndex="cpntTabIndex" 
          :class='classCampo'
          :autocomplete='cpntAutoComplete'
          :autofocus='cpntAutoFocus'
          :disabled='cpntDisabled'
          :placeholder="cpntPlaceholder"

          v-model='value'>

        <!-- {{ buscando }} -->
        <div class="rf-icone-input" v-if='buscando === true'>      
          <RF-Icones
            :cpntId='cpntId + "-icone-input"'
            :cpntIcone='"loadding"'
            :cpntIconeClass='[ "rf-icon-preto" ]'
          ></RF-Icones>
            <!-- :cpntExplica='cpntIcone.explica' -->
        </div>
        <div class="rf-icone-input" :key="cpntValueRef" v-else>
          <RF-Icones v-if='cpntValueRef !== null && cpntValueRef !== ""'
            :cpntId='cpntId + "-icone-input"'
            :cpntIcone='"check-circulo"'
            :cpntIconeClass='[ "rf-icon-verde" ]'
          ></RF-Icones>

          <RF-Icones v-else
            :cpntId='cpntId + "-icone-input"'
            :cpntIcone='"erro"'
            :cpntIconeClass='[ "rf-icon-vermelho" ]'
          ></RF-Icones>
        </div>
      </template>
      <template v-else>
        <div class="input-group">
          <input
            style='padding-right: 30px;'
            :ref='cpntId'
            class="form-control"

            :id='cpntId' 
            :name='cpntId' 
            type="text" 
            :tabIndex="cpntTabIndex" 
            :class='classCampo'
            :autocomplete='cpntAutoComplete'
            :autofocus='cpntAutoFocus'
            :disabled='cpntDisabled'
            :placeholder="cpntPlaceholder"

            v-model='value'>
          <span class="input-group-addon" style="cursor: pointer;" @click="getAutoComplite"><i class="fa fa-search" style="color: #777;"></i></span>
        </div>
      </template>

      <span class="rf-barra"></span>
      <label :for='cpntId' :class='"has-" + cpntMensagemTipo'>
        <span v-html='cpntNome'></span>

        <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'
        ></RF-Explica>
      </label>
      <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>

      <!-- RESULTADO DO AUTO COMPLITE -->
      <ul v-if='options !== null' class="dropdown-menu" role="menu" style='z-index: 2750; display: block; max-height: 270px; overflow-y: auto;' :id="cpntId + '-dropdown-ul'" @mouseleave='onMouseHover' @mouseover='onMouseHover'> 
        <template v-for='(option, index) in options'>
          <li :key="index" :class='"rf-complite-selected-" + (keyPressBlock === false && index === optionSelected)' :data-value="JSON.stringify(option)" @click='onChangeComponent(option)'>
            <span v-for='(key, indexOption) in cpntKeyMostra' v-if='!option.hasOwnProperty("rf-novo")' :key="indexOption">
              <span v-if='inputTipoBusca === true'>
                <span v-html='option.nome'></span>
              </span>
              <span v-else-if='option.hasOwnProperty(key) && key === "placa"' v-html='option[key].toUpperCase()'></span>
              <span v-else-if='option.hasOwnProperty(key)' v-html='option[key]'></span>
              <span v-else v-html='key'></span>
            </span>

            <span v-if='option.hasOwnProperty("rf-novo")' v-html='option["rf-novo"]' style="font-style: italic;"></span>
          </li>
        </template>
        <li v-if='options.length === 0' :class='"rf-complite-selected-true rf-complite-no-value"'>
          <span>Nenhum registro encontrado.</span>
        </li>

        <li v-if='options.length === 0 && Object.keys(cpntAddButForm).length >= 1' class='rf-complite-no-value' style="text-align: center;">
          <RF-Button
            :cpntId='cpntAddButForm.id' 
            :cpntStatus='cpntAddButForm.status' 
            :cpntTexto='cpntAddButForm.texto'
            :cpntClass='cpntAddButForm.class'

            @onClickButton='onAddNovoRegistro(cpntAddButForm.onClickButton, value)'
          ></RF-Button>
        </li>
      </ul>
    </template>
  </div>
</template>

<style>
  .dropdown-menu > li > span > span.rf-destaque {
    font-weight: 600;
    text-decoration: underline;
  }
</style>

<style>
  .rf-input-group > input ~ div > span > svg {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
     -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
       -o-filter: grayscale(100%);
  }
  .rf-input-group > input:focus ~ div > span > svg {
    filter: none;
    -webkit-filter: none;
     -moz-filter: none;
      -ms-filter: none;
       -o-filter: none;
  }
</style>

<style scoped>
  .dropdown-menu {
    padding: 0px;
    max-width: 450px;
    min-width: 450px;
    position: absolute;
    margin-top: -1px;
    top: auto;
    left: auto;

    overflow: hidden;
    white-space: nowrap;
    font-size: var(--font-base-soma-13) !important;
  }
    .dropdown-menu > li {
      padding: 3px 10px;
      cursor: pointer;

      line-height: 35px;

      white-space: normal;
      line-height: 18px;
    }
    .dropdown-menu > li:hover, .dropdown-menu > li.rf-complite-selected-true {
      background: #c5c5c5;
    }
.rf-complite-no-value {
  text-align: center !important;
  background: #dcdcdc !important;
  padding: 3px 10px !important;
  min-width: 270px !important;
}

.rf-complite-no-value ~ .rf-complite-no-value {
  padding: 0px 15px 15px 15px !important;
}

.rf-icone-input {
  position: absolute;
  right: 1px;
  top: 2px;
  margin: 0px 5px;
}

/* -=-=-=-=-=-= ESTILO INICIAL =-=-=-=-=-=- */
.rf-input-group {
  position: relative;
  margin-bottom: 30px;
}

/* ------------------ CONFIGURA O INPUT ------------------ */
.rf-input-group > input {
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #CCC;
  padding: 5px 5px 5px 5px;
  color: #292b2c;
 }
  /* ------------------ REMOVE BORDAS INPUT QUANDO DA FOCUS ------------------ */
  .rf-input-group > input:focus { 
    outline: none; 
  }

/* ------------------ MODO DE ABERTURA DA ANIMAÇÃO ------------------ */
.rf-input-group > input:focus ~ .rf-barra:before, .rf-input-group > input:focus ~ .rf-barra:after {
  width: 50%;
}
.rf-barra:before { 
  left: 50%;
}
.rf-barra:after {
  right: 50%;
}
/* ------------------ APRESENTA A BARRA ABAIXO DO INPUT QUANDO SELECIONADO ------------------ */
.rf-barra {
  position: relative;
  display: block;
  width: 100%;
 }
.rf-barra:before, .rf-barra:after {
  position: absolute;
  bottom: 1px;
  content: '';
  width: 0px;
  height: 2px;
  background: #4285f4;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
 }
/* ------------------ TITULO DO CAMPO ------------------ */
.rf-input-group > label {
  position: absolute;
  left: 0px;
  top: -20px;
  color: var(--color-base-02);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;

  /* padding: 0px 5px; */
  margin: 0px;
 }   
  /* ------------------ LOCAL E COR QUE FICA O TITULO DO CAMPO APÓS PREENCHIDO ------------------ */
  .rf-input-group > input:focus ~ label, .rf-input-group > input.rf-input-focus-true ~ label {
    top: -20px;
  }
  .rf-input-group > input:focus ~ label {
    color: #4285f4;
  }
  /* ------------------ ALTERA A COR CASO NÃO SEJA VALIDADO ------------------ */
    .rf-input-group > input.has-error ~ label {
      top: -20px;
      color: #a94442;
    }
    .rf-input-group > input.has-error ~ .rf-barra:before, .rf-input-group > input.has-error ~ .rf-barra:after {
      position: absolute;
      bottom: 1px;
      content: '';
      width: 0px;
      height: 2px;
      background: #a94442;
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
      width: 50%;
    }

    .rf-input-group > input:disabled {
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      cursor: not-allowed;
    }

.rf-input-group > input {
  padding: 4px 5px 4px 5px;
  border-radius: 5px;
  border: 1px solid #e9e9e9;
  border-bottom: 1px solid #d0d0d0;
  height: 30px;
}
</style>

<script>
  export default {
    name: 'RF-Input-Complite',
    components: {
      'RF-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue'),
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntTabIndex: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return 1
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },
      cpntValueRef: {
        required: true,
        type: [ String, Number ]
      },
      cpntAutoComplete: {
        type: String,
        required: false,
        default: 'off'
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntAutoFocus: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },

      cpntRouter: {
        type: String,
        required: true
      },
      cpntField: {
        type: Object,
        required: true
      },
      cpntFieldVirtual: {
        type: Array,
        required: false,
        default: function () {
          return null
        }
      },
      cpntWhere: {
        type: Object,
        required: false,
        default: function () {
          return {}
        }
      },
      cpntMethod: {
        type: String,
        required: false,
        default: function () {
          return 'GET'
        }
      },
      cpntTipoOrder: {
        type: String,
        required: false,
        default: function () {
          return ''
        }
      },
      cpntOrder: {
        type: Object,
        required: false,
        default: function () {
          return {}
        }
      },
      cpntKeyMostra: {
        type: Array,
        required: true
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntAddButForm: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },

      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnRealizaBusca: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyPressEnter: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        status: '',
        value: this.cpntValue,
        classCampo: [],
        mask: '',
        buscando: false,
        inputTipoBusca: false,

        countVezes: 0,
        options: null,

        optionSelected: 0,
        keyPressBlock: false,
        bloqueado: false
      }
    },
    created: function () {
      document.addEventListener('click', this.onFecharAutoComplite) // Cria um observador de clique na tela
    },
    destroyed: function () {
      document.removeEventListener('click', this.onFecharAutoComplite) // REMOVE OS EVETOS
    },
    mounted: function () {
      this.iniciarCampo()
    },
    methods: {
      onKeyPress: function (event) {
        switch (event.key) {
          case 'ArrowUp':
            if (this.options !== null) {
              this.optionSelected = (this.optionSelected === 0 ? (this.options.length - 1) : (this.optionSelected - 1))
            }
            break

          case 'ArrowDown':
            if (this.options !== null) {
              this.optionSelected = (this.optionSelected >= (this.options.length - 1) ? 0 : (this.optionSelected + 1))
            }
            break

          case 'Enter':
            if (this.options !== null && this.options.length >= 1) {
              this.onChangeComponent(this.options[this.optionSelected]) // CHAMA FUNÇÃO PARA ATULIZAR O VALOR NO COMPONENT PAI
            } else if (this.cpntOnKeyPressEnter !== null) {
              this.cpntOnKeyPressEnter(this.cpntId)
            }
            break
        }
      },
      onChangeComponent: function (objectValue) {
        this.buscando = false
        this.options = null

        if (typeof objectValue === 'object' && Object.keys(objectValue).length >= 1) {
          if (objectValue.hasOwnProperty('rf-novo')) {
            this.onAddNovoRegistro(this.cpntAddButForm.onClickButton, this.value)
          } else {
            // REMOVE AS CHAVES NÃO UTILIZADAS
            for (var key in objectValue) {
              if (key.substring(0, 3) === 'rf-') {
                delete objectValue[key]
              }
            }

            if (this.cpntOnChange !== null) {
              this.cpntOnChange(objectValue, this.cpntId)
            } else {
              // eslint-disable-next-line
              console.log('WEB [409]: Função cpntOnChange não informada para o component com o id (' + this.cpntId + ')')
            }
          }
        }

        // CHAMA A FUNÇÃO PARA FECHAR OS OPTIONS
        this.onFecharAutoComplite()
      },
      onFocusField: function (scroll) {
        // this.$refs[this.cpntId].select() // DA O FOCUS NO CAMPO INFORMADO

        // CHAMA FUNÇÃO PARA DAR FOCUS E DAR SCROOL NA TELA
        this.$store.state.ON_FOCUS_CAMPO('RF-Input-Complite', this.cpntId, scroll)
      },
      iniciarCampo: function () {
        this.inputTipoBusca = '/menu/get/web-buscar/' === this.cpntRouter

        // SETA O STATUS
        this.status = 'carregando'

        // RESETA AS CLASSES DO INPUT
        this.classCampo = []

        // CHAMA FUNÇÃO PARA VERIFICAR SE O CAMPO TEM VALOR
        this.onCheckFocusCampo()

        // ALTERA O STATUS
        this.status = ''
      },
      onCheckFocusCampo: function () {
        // REMOVE AS CLASSES DE FOCUS
        this.classCampo = this.classCampo.filter(item => (item !== 'rf-input-focus-true' && item !== 'rf-input-focus-false'))

        // VERIFICA SE O VALOR FOI PREENCHIDO
        this.classCampo.push((this.value !== '' ? 'rf-input-focus-true' : 'rf-input-focus-false'))
      },
      onFecharAutoComplite: function () {
        this.buscando = false
        this.options = null
      },
      onMouseHover: function (event) {
        switch (event.type) {
          case 'mouseover':
            this.keyPressBlock = true
            break

          case 'mouseleave':
            this.keyPressBlock = false
            break
        }
      },
      onAddNovoRegistro: function (funcao, value) {
        // CHAMA A FUNÇÃO RECEBIDA
        funcao(value)

        // CHAMA A FUNÇÃO PARA FECHAR OS OPTIONS
        this.onFecharAutoComplite()
      },

      // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

      getAutoComplite: function () {
        var self = this

        if (self.value.length >= 2) {
          self.buscando = true
          var queryGet = ''

          if (self.inputTipoBusca === false) {
            queryGet = { type: 'list', field: self.cpntField, where: {}, limit: { row: 0, qty: 100 } }

            // VERIFICA SE DEVE SOLICITAR FIELD VIRTUAL

            if ([ '', null, undefined ].indexOf(self.cpntFieldVirtual) === -1) {
              queryGet.field_virtual = self.cpntFieldVirtual
            }

            if (!self.cpntWhere.hasOwnProperty('aAnd') && !self.cpntWhere.hasOwnProperty('aOr')) {
              if (self.cpntWhere.hasOwnProperty('o') && self.cpntWhere.o === 's.ft') {
                self.cpntWhere.v = self.value
              }
            } else {
              for (var key1 in self.cpntWhere) {
                for (var key2 in self.cpntWhere[key1]) {
                  if (!self.cpntWhere[key1][key2].hasOwnProperty('aAnd') && !self.cpntWhere[key1][key2].hasOwnProperty('aOr')) {
                    if (self.cpntWhere[key1][key2].hasOwnProperty('o') && self.cpntWhere[key1][key2].o === 's.ft') {
                      self.cpntWhere[key1][key2].v = self.value
                    }
                  } else {
                    for (var key3 in self.cpntWhere[key1][key2]) {
                      for (var key4 in self.cpntWhere[key1][key2][key3]) {
                        if (self.cpntWhere[key1][key2][key3][key4].hasOwnProperty('o') && self.cpntWhere[key1][key2][key3][key4].o === 's.ft') {
                          self.cpntWhere[key1][key2][key3][key4].v = self.value
                        }
                      }
                    }
                  }
                }
              }
            }

            queryGet.where = self.cpntWhere

            // VERIFICA SE DEVE ADICIONAR O ORDER NA PESQUISA
            if ([ '', null, undefined ].indexOf(self.cpntOrder) === -1 && Object.keys(self.cpntOrder).length >= 1) {
              switch (self.cpntTipoOrder) {
                case 'numero':
                  if (isNaN(self.value) === false) {
                    queryGet.order = self.cpntOrder
                  }
                  break
                
                default:
                  queryGet.order = self.cpntOrder
                  break
              }
            }
          } else {
            queryGet = encodeURI(window.btoa(unescape(encodeURIComponent(self.value))))
          }

          // VERIFICA SE DEVE SUBSTITUIR ALGUM VALOR
          if ([ '', null, undefined ].indexOf(queryGet) === -1 && [ '', null, undefined ].indexOf(queryGet.where) === -1) {
            // CONVERTE EM STRING
            queryGet.where = JSON.stringify(queryGet.where)
  
            // CONVERTE TODOS OS VALORES DE BUSCA
            while (queryGet.where.indexOf('#BUSCA#') !== -1) {
              queryGet.where = queryGet.where.replace('#BUSCA#', self.value)
            }
  
            // CONVERTE O VALOR EM OBJETO
            queryGet.where = JSON.parse(queryGet.where)
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI(self.cpntRouter, self.cpntMethod, queryGet, function (apiSuccess) {
            // VERIFICA SE DEVE CONVERTER OS VALORES RECEBIDOS
            if (apiSuccess.data.length >= 1 && apiSuccess.data[0].hasOwnProperty('ref_modelo') && apiSuccess.data[0].hasOwnProperty('placa')) {
              for (var key in apiSuccess.data) {
                if (apiSuccess.data[key].ref_modelo !== '') {
                  apiSuccess.data[key].id_mod_nome = apiSuccess.data[key].ref_modelo_j_modelo
                  apiSuccess.data[key].id_mar_nome = apiSuccess.data[key].ref_modelo_id_marca_j_marca
                }
              }
            }

            self.options = apiSuccess.data

            if (self.options.length >= 1 && Object.keys(self.cpntAddButForm).length >= 1) {
              var objeto = {}
              objeto['rf-novo'] = self.cpntAddButForm.texto
              self.options.push(objeto)
            }

            self.buscando = false

            self.optionSelected = 0
            
            if ([ '', null, undefined ].indexOf(self.$refs[self.cpntId]) === -1) {
              self.$refs[self.cpntId].focus()
            }

            if (self.inputTipoBusca === true) {
              setTimeout(function () {
                $('#' + self.cpntId + '-dropdown-ul > li').on('mousedown', function (event) {
                  event.stopPropagation()
                  event.preventDefault()

                  if (event.which === 2 || (event.ctrlKey === true && event.which === 1)) {
                    // SETA O CLICK NO SCROLL
                    self.$store.commit('SET_BUTTON_CLICK_SCROLL', self.cpntId)

                    // CHAMA A FUNÇÃO ONCHAGE
                    self.onChangeComponent($(this).data('value'))
                  }
                })
              }, 500)
            }
          }, function (apiError) {
            self.status = apiError // SETA O STATUS RECEBIDO
          })
        }
      }
    },
    watch: {
      'value': function () {
        if (this.bloqueado === false) {
          // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
          this.onCheckFocusCampo()

          // LIMPA OS OPTIONS EXISTENTES
          this.options = null

          // SALAVA A QUANTIDADE DE DIGITOS
          this.countVezes++
          var conta = this.countVezes

          // BLOQUEIA A BUSCA NA API
          this.buscando = true
        }

        // VERIFICA SE TEM FUNÇÃO REALIZA BUSCA DEFINIDA
        if (this.cpntOnRealizaBusca !== null && this.cpntValue !== this.value) {
          this.cpntOnRealizaBusca(this.value)
        }

        if (this.value.length >= 2) {
          var self = this

          setTimeout(function () {
            if (self.countVezes === conta && self.value.length >= 2) {
              self.getAutoComplite()
            } else if (self.countVezes === conta && self.value.length <= 1) {
              self.buscando = false
            }
          }, 400)
        } else {
          this.buscando = false
        }
      },
      'cpntValue': function () {
        if (this.cpntValue !== this.value) {
          var self = this

          // BLOQUEA O AUTO COMPLITE
          self.bloqueado = true

          // SETA O VALOR DO INPU
          self.value = self.cpntValue

          // LIMPA TODOS OS OPTIONS
          self.options = null

          // DESATIVA O ICONE DE BUSCA
          self.buscando = false

          // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
          self.onCheckFocusCampo()

          setTimeout(function () {
            self.bloqueado = false // BLOQUEA O AUTO COMPLITE
          }, 100)
        }
      }
    }
  }
</script>
